import moment from "moment";

moment.updateLocale("en", {
  week: {
    dow: 1 // Monday is the first day of the week.
  }
});

export default {
  methods: {
    mFormatDate(date, format) {
      return date ? moment(date).format(format) : "-";
    },
    mFormatTime(date) {
      return date
        ? moment(date).format("hh:mm:ss A")
        : moment().format("hh:mm:ss A");
    },
    mFormatShortDate(date, format) {
      if (!date) {
        return "-";
      }
      switch (format) {
        case "d-m-y":
          return moment(date).format("Do MMM, YYYY");
        case "d-m":
          return moment(date).format("Do MMM");
        case "m-d":
          return moment(date).format("MMM Do");
        default:
          return "-";
      }
    },
    mFormatIntervalDate(date, interval) {
      return moment(date)
        .add(interval, "day")
        .format("YYYY-MM-DD");
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatPeriodDate(period) {
      switch (period) {
        case "last90":
          return moment()
            .subtract(90, "days")
            .format("YYYY-MM-DD");
        case "last60":
          return moment()
            .subtract(60, "days")
            .format("YYYY-MM-DD");
        case "last30":
          return moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD");
        case "lastweek":
          return moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD");
        default:
          return;
      }
    }
  }
};
